import React from 'react';
import { AppointmentType, AppointmentStatus } from './appointmentService';

const TYPE_OPTIONS: AppointmentType[] = [
  'CONSULTA',
  'RAYOS X',
  'TOMOGRAFIA',
  'RESONANCIA',
  'ULTRASONIDO',
  'MAMOGRAFIA',
  'SEGUIMIENTO',
];
const STATUS_OPTIONS: AppointmentStatus[] = ['PENDIENTE', 'CONFIRMADA', 'COMPLETADA', 'CANCELADA'];

const AppointmentFormModal = ({
  isDialogOpen,
  editingAppointment,
  formData,
  setFormData,
  handleSubmit,
  resetForm,
}) => {
  if (!isDialogOpen) {
    return null;
  }

  const title = editingAppointment ? 'Editar Cita' : 'Agendar Nueva Cita';

  const handleFieldChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const inputClass =
    'focus:ring-primary-main w-full rounded border bg-black px-3 py-2 focus:outline-none focus:ring';
  const selectClass =
    'focus:ring-primary-main bg-primary-main w-full rounded border px-3 py-2 focus:ring';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 text-white">
      <div className="bg-primary-dark max-h-[90vh] max-w-lg overflow-y-auto rounded p-6 shadow-lg sm:w-full">
        <h3 className="mb-4 text-xl font-semibold">{title}</h3>
        <form
          onSubmit={handleSubmit}
          className="space-y-4"
        >
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {/* ID de Paciente (Obligatorio) */}
            <div>
              <label className="block text-sm font-medium">ID de Paciente (Código)</label>
              <input
                type="text"
                name="patientIdCode"
                value={formData.patientIdCode}
                onChange={handleFieldChange}
                className={inputClass}
                required
                disabled={!!editingAppointment} // No permitir editar el ID de paciente en edición
              />
            </div>
            {/* Fecha y Hora */}
            <div>
              <label className="block text-sm font-medium">Fecha y Hora</label>
              <input
                type="datetime-local" // Usamos este tipo para facilitar la captura de hora
                name="date"
                value={formData.date}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>
            {/* Tipo de Cita */}
            <div>
              <label className="block text-sm font-medium">Tipo de Cita</label>
              <select
                name="type"
                value={formData.type}
                onChange={handleFieldChange}
                className={selectClass}
                required
              >
                {TYPE_OPTIONS.map(type => (
                  <option
                    key={type}
                    value={type}
                  >
                    {type.charAt(0).toUpperCase() + type.slice(1).toLowerCase().replace('_', ' ')}
                  </option>
                ))}
              </select>
            </div>
            {/* Estado (Solo editable en edición) */}
            {editingAppointment && (
              <div>
                <label className="block text-sm font-medium">Estado</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleFieldChange}
                  className={selectClass}
                  required
                >
                  {STATUS_OPTIONS.map(status => (
                    <option
                      key={status}
                      value={status}
                    >
                      {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {/* Motivo de la Cita (Full Width) */}
          <div>
            <label className="block text-sm font-medium">Motivo/Servicio</label>
            <input
              type="text"
              name="reason"
              value={formData.reason}
              onChange={handleFieldChange}
              className={inputClass}
              required
            />
          </div>

          {/* Notas */}
          <div>
            <label className="block text-sm font-medium">Notas Adicionales</label>
            <textarea
              name="notes"
              value={formData.notes || ''}
              onChange={handleFieldChange}
              className={inputClass}
              rows={3}
            />
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={resetForm}
              className="rounded bg-red-700 px-4 py-2 text-white hover:bg-red-500"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-900"
            >
              {editingAppointment ? 'Actualizar Cita' : 'Agendar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AppointmentFormModal;
